import React from 'react'
import Subheader from '../../component/Subheader'
import BlogCard from './BlogCard'

export default function Blog({initialData}) {
    const subheadData = {
      image: '../image/blog-banner.webp',
      heading: 'From the Loom Heritage, Fashion, Culture',
      pagename: 'Blog listing',
    }

  return (
    <>
    <Subheader subheadData={subheadData}/>
    <BlogCard initialData={initialData}/>
    </>
  )
}
